import { Icon } from "../../Icon";

export const talentResourceIcon = new Icon(
    `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path fill-rule="nonzero" d="M32 5.333c14.704 0 26.667 11.963 26.667 26.667 0 14.704-11.963 26.667-26.667 26.667C17.296 58.667 5.333 46.704 5.333 32 5.333 17.296 17.296 5.333 32 5.333ZM32 0C14.328 0 0 14.328 0 32s14.328 32 32 32 32-14.328 32-32S49.672 0 32 0Zm1.816 41V26.89h4.653v-3.023H25.53v3.024h4.653V41h3.632Z"/></svg>`
);
